import {createFileRoute} from '@tanstack/react-router';
import {ConnectBankSuccessPage} from 'features/saved-accounts/pages/ConnectBankSuccessPage';

export const Route = createFileRoute(
  '/_protected/home/service/connect-bank/success',
)({
  component: ConnectBankSuccessPage,
});
